var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'button': (_vm.custom.render(_vm.scope) && _vm.custom.render(_vm.scope)!='--')},style:(_vm.custom.getStyle && _vm.custom.getStyle(_vm.scope)),on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.custom.render(_vm.scope)))])}
var staticRenderFns = []

export { render, staticRenderFns }